export const MindUpAdminMobileAllReservationConsultationMenu = ['전체', '요청 전', '예약 대기'];
